import { Injectable} from '@angular/core';
import { Headers, RequestOptions, Http } from '@angular/http';
import * as intl from '../app.intl.json';

@Injectable()
export class IntlService {

    data;

    constructor(private http: Http) { 
        this.data = intl;
    }

    // constructor(private http: Http) { 
    //     this.http.get('/api/intl').subscribe(response => {
    //         this.data = response.json();
    //     })
    // }

    // get(): Promise<any> {
    //     return this.http.get('/api/intl')
    //         .toPromise()
    //         .then(response => {
    //             this.data = response.json();
    //             return this.data;
    //         })
    // }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/intl.service.ts